import * as yup from "yup";

import { EMAIL_REGEX } from "src/constants";

const spaceCheckYupValidation = (val?: string) =>
  val ? !/^\s*$/.test(val) : false;

export const AddCaseSchema = (ref_type: string) =>
  yup.object({
    mos: yup.string().required(),
    submission_source: yup.string().required(),
    user_id: yup.number().required(),
    creator_name: yup.string().required(),
    doctor_firstlastname: yup.string(),
    doctor_fullname: yup.string(),
    patient_firstlastname: yup.string(),
    patient_fullname: yup.string(),
    patient_dob: yup.string(),
    practice_name: yup.string(),
    original_id: yup.number(),
    category: yup.string(),

    procedure_attributes: yup
      .object({
        cpt_code: yup.string().required("Procedure is required"),
      })
      .required("Procedure is required"),

    prescription_attributes: yup
      .object({
        drug_id: yup.number(),
        drug_name: yup.string().required("Please select a drug to continue"),
        diagnosis_code: yup
          .array()
          .of(yup.string().required(`Diagnosis code is required`))
          .min(1, `Diagnosis code is required`)
          .required(`Diagnosis code is required`),
        direction: yup
          .string()
          .max(255, "Direction should only be 255 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Direction should not contain only spaces",
                (val) => spaceCheckYupValidation(val)
              ),
          }),
        note: yup
          .string()
          .max(70, "Note should only be 70 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Not should not contain only spaces",
                (val) => spaceCheckYupValidation(val)
              ),
          }),
        // injection_site: yup
        //   .string()
        //   .when("product", {

        //     is: (prod?: string) => prod && prod === "zilretta",
        //     then: (schema) => schema.required("Knees is required."),
        //     otherwise: (schema) => schema.required("Treatments Area is required."),
        //   }),
        injection_site: yup.string().when("drug_name", {
          is: (prod?: string) => {
            // console.log('Product:', prod); // Log the product value
            return prod && prod === "zilretta";
          },
          then: (schema) => {
            // console.log('Zilretta selected, making injection_site required');
            return schema.required("Knees is required.");
          },
          otherwise: (schema) => {
            // console.log('Other product selected, making injection_site required');
            return schema.required("Treatment Area is required.");
          },
        }),
        scheduled_date_of_service: yup.string(),
        written_date: yup.string(),
        is_specialty_pharmacy_only: yup.boolean().when("product", {
          is: (prod?: string) => prod && prod === "zilretta",
          then: (schema) => schema.default(false),
        }),
        has_been_treated: yup
          .string<"Yes" | "No" | "Unsure" | "">()
          .oneOf(["Yes", "No", "Unsure", ""], "Please select an option")
          .when("drug_name", {
            is: (drug: string) => {
              return drug && drug.includes("zil") ? true : false;
            },
            then: (schema) =>
              schema.required("ZILRETTA treatment option is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
        last_date_of_service: yup.string().when("has_been_treated", {
          is: (val: string) => val === "Yes",
          then: (schema) =>
            schema.required("Date of Last ZILRETTA injection is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        is_daw: yup.string().required(),
        nerves_qty: yup
          .number()
          .max(5, "Nerves Qty should be less than 6")
          .min(0)
          .typeError("Nerves Qty should be a valid number"),
        qty: yup
          .number()
          .max(2, "Nerves Qty should be less than 3")
          .min(1)
          .typeError("Qty should be a valid number"),
        nerves: yup
          .array()
          .of(yup.string().required())
          .max(5, "Maximum 5 names can be selected"),
        treatment_date: yup.string(),
        additional_nerves: yup.string(),
        other_nerves: yup.string(),
        last_surgical_date: yup.string(),
        // is_us_citizen: yup
        //   .boolean()
        //   .nullable()
        //   .when("drug_name", ([drugName], schema) => {
        //     if (drugName === "iovera°") {
        //       return schema.notRequired().nullable();
        //     }
        //     return schema
        //       .required("US citizen info is required")
        //       .nullable()
        //       .test(
        //         "not-null",
        //         "US citizen info is required",
        //         (value) => value !== null && value !== undefined
        //       );
        //   }),

        // is_enrolled_in_federal: yup
        //   .boolean()
        //   .nullable()
        //   .when("drug_name", ([drugName], schema) => {
        //     if (drugName === "iovera°") {
        //       return schema.notRequired().nullable();
        //     }
        //     return schema
        //       .required("Patient enrollment status is required")
        //       .nullable()
        //       .test(
        //         "not-null",
        //         "Patient enrollment status is required",
        //         (value) => value !== null && value !== undefined
        //       );
        //   }),
      })
      .required(`prescription attributes are required`),

    patient_attributes: yup
      .object({})
      .when("prescription_attributes", (prescription_attributes: { drug_name: string }[]) => {
         const drugName =
            prescription_attributes.length > 0
              ? prescription_attributes[0]?.drug_name
              : "";
        //:- if drug is iovera
        return yup.object({
          global_patient_id: yup
          .number()
          .default(0)
          .required(`Patient is required`),
        title: yup.string(),
        firstname: yup
          .string()
          .required("First name is required")
          .max(34, "First name should only be 34 characters long")
          .test(
            "whiteSpaceRemoval",
            "First name should not contain only spaces",
            (val) => spaceCheckYupValidation(val)
          ),
        middlename: yup
          .string()
          .max(34, "Middle name should only be 34 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Middle name should not contain only spaces",
                (val) => spaceCheckYupValidation(val)
              ),
          }),
        lastname: yup
          .string()
          .required("Last name is required")
          .max(34, "Last name should only be 34 characters long")
          .test(
            "whiteSpaceRemoval",
            "Last name should not contain only spaces",
            (val) => spaceCheckYupValidation(val)
          ),
        ssn: yup.string().when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema
              .min(9, "SSN should be 9 digits long")
              .max(9, "SSN should be 9 digits long")
              .test(
                "containAllDigits",
                "SSN should only contain digits",
                (val) => (val ? /^\d+$/.test(val) : false)
              ),
        }),
        dob: yup
          .string()
          .required("DOB is required")
          .test(
            "dates-test",
            "Date of Birth should be less than present date",
            (value: string) => {
              const dob = new Date().toISOString().substring(0, 10);
              return dob >= value;
            }
          ),
        is_us_citizen: yup.boolean()
          .nullable()
          .when({
            is: () => {
              if (drugName === "iovera°") return false;
              return true;
            },
            then: (schema) => schema
              .required("US citizen info is required")
              .test(
                "not-null",
                "US citizen info is required",
                (value) => value !== null && value !== undefined
              ),
            otherwise: (schema) => schema.notRequired(),
          }),
        is_enrolled_in_federal: yup
          .boolean()
          .nullable()
          .when({
            is: () => {
              if (drugName === "iovera°") return false;
              return true;
            },
            then: (schema) => schema
              .required("Patient enrollment status is required")
              .test(
                "not-null",
                "Patient enrollment status is required",
                (value) => value !== null && value !== undefined
              ),
            otherwise: (schema) => schema.notRequired(),
          }),
        
        patient_email_id: yup.number().required().nullable(),
        patient_email: yup.string().when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema
              .max(70, "Email should only be 70 characters long")
              .test(
                "isEmailValid",
                "Email should be a valid email",
                (val?: string) => (val && EMAIL_REGEX.test(val) ? true : false)
              ),
        }),
        gender: yup.string().required("Gender is required"),
        best_time_to_contact: yup.string(),
        phone_numbers: yup
          .array()
          .of(
            yup.object({
              phone_type: yup.string().required("Phone type is required"),
              number: yup
                .string()
                .required(`Phone number is required`)
                .min(10, `Phone number invalid`)
                .max(10, `Phone number invalid`)
                .test("range", "Phone number invalid", (val) => {
                  const numberedVal = Number(val);
                  if (!isNaN(numberedVal)) {
                    if (numberedVal > 2000000000 && numberedVal < 9999999999)
                      return true;
                  }
                  return false;
                }),
              is_preferred: yup
                .boolean()
                .default(false)
                .required("Preferred phone is required"),
              is_ok_to_leave_message: yup
                .boolean()
                .default(false)
                .required("OK to leave message is required"),
              id: yup.number().required().nullable(),
            })
          )
          .min(1, "At least one phone number is required for patient")
          .required(`at least one phone number is required for patient`),

        address: yup
          .object({
            street: yup
              .string()
              .required(`Street is required`)
              .max(255, "Street should only be 255 characters long")
              .test(
                "whiteSpaceRemoval",
                "Street should not contain only spaces",
                (val) => spaceCheckYupValidation(val)
              ),
            suite: yup
              .string()
              .max(255, "Suite should only be 255 characters long")
              .when({
                is: (val: string) => val && val.length > 0,
                then: (schema) =>
                  schema.test(
                    "whiteSpaceRemoval",
                    "Suite should not contain only spaces",
                    (val) => spaceCheckYupValidation(val)
                  ),
              }),
            city: yup
              .string()
              .required(`City is required`)
              .max(255, "City should only be 255 characters long")
              .test(
                "whiteSpaceRemoval",
                "City should not contain only spaces",
                (val) => spaceCheckYupValidation(val)
              ),
            state: yup.string().required(`State is required`),
            zip: yup
              .string()
              .required(`Zip is required`)
              .max(9, "Zip should not be more than 9 digits")
              .test(
                "containAllDigits",
                "Zip should only contain digits",
                (val) => (val ? /^\d+$/.test(val) : false)
              ),
            address_name: yup.string().required(`Address type is required`),
          })
          .required(`Address for patient information is required`),
        })
        .required(`Patient details are required`);
      }),

    doctor_attributes: yup
      .object({})
      .when(
        "prescription_attributes",(prescription_attributes: { drug_name: string }[]) => {
          const drugName =
            prescription_attributes.length > 0
              ? prescription_attributes[0]?.drug_name
              : "";
          if (drugName && drugName === "iovera°") {
            // Condition where drug_name is exactly "iovera°"
            return yup.object({
              submitting_practice_id: yup.number().when({
                is: () => ref_type.toLowerCase().includes("organization"),
                then: (schema) =>
                  schema.required("Submitting Practice is required"),
                otherwise: (schema) => schema.notRequired(),
              }),
              i_am: yup
                .string()
                .required("Referring or Treating practice is required"),
              is_anesthesiologist: yup.boolean(),
              treating_practice_id: yup
                .number()
                .required("Treating Practice is required")
                .min(1, "Treating Practice is required"),
              // treating_doctor_id: yup
              //   .number().when("is_anesthesiologist",{
              //     is:(val: boolean) => val === true ,then:(schema) =>
              //       schema
              //     .required("Treating Provider is required")
              //     .min(1, "Treating Provider is required"),
              //     otherwise: (schema) => schema.required("Treating Facility is required")
              //     .min(1, "Treating Facility is required"),
              //   }),
              treating_doctor_id: yup.number().when("is_anesthesiologist", {
                is: (is_anesthesiologist: boolean) => {
                  if (
                    ref_type.length > 0 &&
                    ["Practice", "Contact"].includes(ref_type)
                  ) {
                    if (is_anesthesiologist) return true;
                    else return false;
                  } else return false;
                },
                then: (schema) =>
                  schema
                    .required("Treating Facility is required")
                    .min(1, "Treating Facility is required"),
                otherwise: (schema) =>
                  schema
                    .required("Treating Provider is required")
                    .min(1, "Treating Provider is required"),
              }),
              referring_practice_id: yup.number().when("i_am", {
                is: (i_am?: string) => {
                  return i_am
                    ? !["Treating Facility", "Treating Provider"].includes(i_am)
                    : false;
                },
                then: (schema) =>
                  schema
                    .required("Referring Practice is required")
                    .min(1, "Referring Practice is required"),
                otherwise: (schema) => schema.notRequired(),
              }),
              referring_doctor_id: yup.number().when("referring_practice_id", {
                is: (referring_practice_id: number | null | undefined) => {
                  return referring_practice_id ? true : false;
                },
                then: (schema) =>
                  schema
                    .required("Referring Provider is required")
                    .min(1, "Referring Provider is required"),
                otherwise: (schema) => schema.notRequired(),
              }),
            });
          } else {
            // Default case: any other drug name or missing prescription_attributes
            return yup.object({
              practice_id: yup.number().required("Practice is required"),
              global_doctor_id: yup
                .number()
                .required("Administrative provider is required"),
            });
          }
        }
      ),

    insurances_attributes: yup
      .array()
      .of(
        yup.object({
          insurance_name: yup
            .string()
            .required(`Insurance Name is required`)
            .test(
              "whiteSpaceRemoval",
              "Insurance Name should not contain only spaces",
              (val) => spaceCheckYupValidation(val)
            ),
          relation_to_patient: yup
            .string()
            .required(`Relation to patient is required`),
          relation_firstname: yup
            .string()
            .max(35, "First name should only be 35 characters long")
            .when("relation_to_patient", {
              is: (relation: string) => relation && relation !== "self",
              then: (schema) => schema.required("First name is required"),
            })
            .when({
              is: (val: string) => val && val.length > 0,
              then: (schema) =>
                schema.test(
                  "whiteSpaceRemoval",
                  "First name should not contain only spaces",
                  (val) => spaceCheckYupValidation(val)
                ),
            }),
          relation_middlename: yup
            .string()
            .max(35, "Middle name should only be 35 characters long")
            .when({
              is: (val: string) => val && val.length > 0,
              then: (schema) =>
                schema.test(
                  "whiteSpaceRemoval",
                  "Middle name should not contain only spaces",
                  (val) => spaceCheckYupValidation(val)
                ),
            }),
          relation_lastname: yup
            .string()
            .max(35, "Last name should only be 35 characters long")
            .when("relation_to_patient", {
              is: (relation: string) => relation && relation !== "self",
              then: (schema) => schema.required("Last name is required"),
            })
            .when({
              is: (val: string) => val && val.length > 0,
              then: (schema) =>
                schema.test(
                  "whiteSpaceRemoval",
                  "Last name should not contain only spaces",
                  (val) => spaceCheckYupValidation(val)
                ),
            }),

          policy: yup
            .string()
            .required(`Member id is required`)
            .test(
              "whiteSpaceRemoval",
              "Member id should not contain only spaces",
              (val) => spaceCheckYupValidation(val)
            ),
          group_number: yup
            .string()
            .max(45, "Group should only be 45 characters long")
            .when({
              is: (val: string) => val && val.length > 0,
              then: (schema) =>
                schema.test(
                  "whiteSpaceRemoval",
                  "Group should not contain only spaces",
                  (val) => spaceCheckYupValidation(val)
                ),
            }),
          insurance_number: yup.string().when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema
                .min(10, `Insurance phone number invalid`)
                .max(10, `Insurance phone number invalid`)
                .test("range", "Insurance phone number invalid", (val) => {
                  const numberedVal = Number(val);
                  if (!isNaN(numberedVal)) {
                    if (numberedVal > 2000000000 && numberedVal < 9999999999)
                      return true;
                  }
                  return false;
                }),
          }),

          member_id: yup
            .string()
            .max(55, "Rx member id should only be 55 characters long")
            .when({
              is: (val: string) => val && val.length > 0,
              then: (schema) =>
                schema.test(
                  "whiteSpaceRemoval",
                  "Rx member id should not contain only spaces",
                  (val) => spaceCheckYupValidation(val)
                ),
            }),
          bin: yup.string().when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema
                .max(6, "bin should be 6 digits long")
                .test(
                  "containAllDigits",
                  "bin should only contain digits",
                  (val) => spaceCheckYupValidation(val)
                ),
          }),
          pcn: yup
            .string()
            .max(45, "PCN should only be 45 characters long")
            .when({
              is: (val: string) => val && val.length > 0,
              then: (schema) =>
                schema.test(
                  "whiteSpaceRemoval",
                  "PCN should not contain only spaces",
                  (val) => spaceCheckYupValidation(val)
                ),
            }),
          rx_group: yup
            .string()
            .max(45, "Rx group should only be 45 characters long")
            .when({
              is: (val: string) => val && val.length > 0,
              then: (schema) =>
                schema.test(
                  "whiteSpaceRemoval",
                  "Rx group should not contain only spaces",
                  (val) => spaceCheckYupValidation(val)
                ),
            }),

          is_primary_insurance: yup.boolean().required(),
          insurance_priority: yup.number().required(),
          global_insurance_id: yup.string().required().nullable(),
        })
      )
      .min(1, "At least one insurance information is required")
      .required("Patient insurance information is required"),
    shipments_attributes: yup.array().of(
      yup.object({
        practice_id: yup.number(),
        practice_type: yup.string(),
        ship_to_street: yup.string(),
        ship_to_suite: yup.string(),
        ship_to_city: yup.string(),
        ship_to_state: yup.string(),
        ship_to_zip: yup.string(),
        ship_to: yup.string(),
        phone: yup.string(),
        fax: yup.string(),
      })
    ),
  });
